import { StyleSheet } from "react-native";

export const fontSize = {
  tiny: 4,
  smaller: 10,
  small: 12,
  medium: 14,
  large: 16,
  larger: 20,
  largerPlus: 28,
  huge: 30,
  massive: 36,
};

// Paragraph = fontSize 12
// Caption = fontSize 12
// Headline = fontSize 24 lineHeight

/**
 * These are not used anywhere, btu exist to communicate to the developer what styles are defaulted for the various
 * Typography components react native paper provides
 * https://github.com/callstack/react-native-paper/tree/master/src/components/Typography
 */
const HeadlinePaperStyle = StyleSheet.create({
  text: {
    fontSize: 24,
    lineHeight: 32,
    marginVertical: 2,
    letterSpacing: 0,
  },
});
const ParagraphPaperStyle = StyleSheet.create({
  text: {
    fontSize: 14,
    lineHeight: 20,
    marginVertical: 2,
    letterSpacing: 0.25,
  },
});

const CaptionPaperStyle = StyleSheet.create({
  text: {
    fontSize: 12,
    lineHeight: 20,
    marginVertical: 2,
    letterSpacing: 0.4,
  },
});

const SubHeadingPaperStyle = StyleSheet.create({
  text: {
    fontSize: 16,
    lineHeight: 24,
    marginVertical: 2,
    letterSpacing: 0.5,
  },
});

const TitlePaperStyle = StyleSheet.create({
  text: {
    fontSize: 20,
    lineHeight: 30,
    marginVertical: 2,
    letterSpacing: 0.15,
  },
});

const SizeHierachy = [
  CaptionPaperStyle,
  ParagraphPaperStyle,
  SubHeadingPaperStyle,
  TitlePaperStyle,
  HeadlinePaperStyle,
];
